import Box from "@mui/material/Box";
import CardMedia from "../Media/CardMedia";
import GalleryItem from "../Gallery/GalleryItem";
import {
  acceptedFormatsPreview,
  buildAdMediaGalleryItem,
  getValidMediaUrls,
} from "./adMediaPreviewUtils";

//eslint-disable-next-line
export const adMediaPreviewTooltipSlotProps = {
  tooltip: {
    sx: {
      backgroundColor: "#FFFFFF",
      color: "text.primary",
      p: 0,
      maxWidth: "unset",
      borderRadius: 3,
      border: "1px solid #E5E5E5",
      boxShadow: "0 8px 24px rgba(0, 0, 0, 0.18)",
      overflow: "hidden",
    },
  },
  arrow: {
    sx: {
      color: "#FFFFFF",
    },
  },
};

const DEFAULT_PREVIEW_WIDTH = 280;

export const adMediaHoverPreviewHeight = {
  xs: "min(280px, 55vh)",
  sm: "min(340px, 60vh)",
  md: "min(400px, 65vh)",
  lg: "min(460px, 68vh)",
  xl: "min(520px, 70vh)",
};

export const adMediaHoverPreviewMaxWidth = {
  xs: "min(320px, 78vw)",
  sm: "min(400px, 58vw)",
  md: "min(480px, 48vw)",
  lg: "min(520px, 40vw)",
  xl: "min(560px, 36vw)",
};

const sxTooltipContainer = {
  p: 1,
};

const onNoop = () => {};

const previewMediaPropsType = {
  controls: false,
  autoplay: false,
  muted: true,
};

const AdMediaPreviewTooltipContent = ({
  mediaUrls = [],
  width = DEFAULT_PREVIEW_WIDTH,
  height,
}) => {
  const validUrls = getValidMediaUrls(mediaUrls);
  const galleryItem = buildAdMediaGalleryItem(validUrls);
  const isCarouselPreview = validUrls.length > 1;

  if (!galleryItem) {
    return null;
  }

  if (height) {
    return (
      <Box sx={{ ...sxTooltipContainer, width: "max-content", lineHeight: 0 }}>
        <CardMedia
          eager
          url={validUrls[0]}
          propsType={previewMediaPropsType}
          sx={{
            "&.MuiCardMedia-media": {
              display: "block",
              width: "auto",
              height: "auto",
              maxHeight: height,
              maxWidth: adMediaHoverPreviewMaxWidth,
              objectFit: "contain",
              borderRadius: 2,
            },
          }}
        />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        ...sxTooltipContainer,
        width,
        maxWidth: width,
        pb: isCarouselPreview ? 1.5 : sxTooltipContainer.p,
      }}
    >
      <GalleryItem
        item={galleryItem}
        index={0}
        multiple={false}
        isSelected={false}
        showActionButtons={false}
        showDeleteButton={false}
        showDimensionsOverlay={false}
        showResizeFormatButton={false}
        overlayPickerMode={false}
        acceptedFormats={acceptedFormatsPreview}
        onSelectItem={onNoop}
        onSelectPreview={onNoop}
        onDeleteItem={onNoop}
        onDownloadItems={onNoop}
        onFailedLoadUrl={onNoop}
      />
    </Box>
  );
};

export default AdMediaPreviewTooltipContent;
